 <template>
  <div>
    <div
      class="global-style"
      :style="`background:${background_card}; color:${text_color}`"
    >
      <div class="flex-container">
        <div class="left-container mb-4">
          <div class="left-sub-container">
            <div class="show-img" style="text-align: left !important">
              <img class="img-left" :src="imagen_left" :alt="tittle" />
            </div>
            <div
              class="text-left mt-4"
              v-if="evaluation_criteria_texts.length > 0"
            >
              <div class="mb-3" :style="`color:${highlighted_color}`">
                <strong> Criterios de evaluación </strong>
              </div>
              <div
                v-for="(item, index) in evaluation_criteria_texts"
                :key="index"
              >
                <div
                  class="index-styles mr-3"
                  :style="`background: ${highlighted_color};color:${background_card}`"
                >
                  <div class="index-text text-center">
                    {{ index + 1 }}
                  </div>
                </div>
                <div class="ml-4">{{ item.text }}</div>
                <ul v-if="item.contents">
                  <li
                    v-for="(li, index2) in item.contents"
                    :key="index + '-' + index2"
                  >
                    {{ li }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="left-container mb-4 hidden-img">
            <div style="text-align: left !important">
              <img class="img-left" :src="imagen_left" :alt="tittle" />
            </div>
          </div>
          <div class="tittle-style d-flex mr-2">
            <img
              style="margin-top: 0.5rem"
              class="mr-3"
              :src="tittle_icon"
              :alt="tittle"
            />
            <span>
              <strong :style="`color:${highlighted_color};`"
                >Curso {{ counter }}:
              </strong>
              {{ tittle }}
            </span>
          </div>
          <div
            :style="`color:${highlighted_color};`"
            class="mt-1 duration-style"
          >
            Duración: {{ duration_text }}
          </div>
          <div class="mt-3 content-style">
            <div
              class="d-flex"
              :style="`border-right: ${text_color} 1px solid;`"
            >
              <svg
                width="22"
                height="22"
                class="mr-3"
                style="margin-top: auto; margin-bottom: auto"
                viewBox="0 0 22 22"
                :fill="`${highlighted_color}`"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.8503 18.5389C21.7523 19.0312 21.6138 19.508 21.3589 19.9468C20.5196 21.3909 18.9044 22.1499 17.2809 21.8566C15.6595 21.5638 14.3981 20.2652 14.1326 18.6093C14.1061 18.443 14.0461 18.3718 13.8648 18.374C13.0872 18.3833 12.3097 18.3833 11.5321 18.374C11.3442 18.3718 11.2807 18.439 11.3005 18.6172C11.3671 19.2192 10.8824 19.807 10.126 19.7977C8.31407 19.7747 6.50219 19.7907 4.69031 19.7902C3.95373 19.7898 3.52326 19.3687 3.52855 18.6318C3.52987 18.4226 3.46019 18.3731 3.26303 18.3726C2.83167 18.3718 2.39723 18.4209 1.96852 18.3297C0.821756 18.0856 0.00799642 17.0878 0.00314474 15.9121C-0.000824818 14.9559 -0.00126588 13.9996 0.00314474 13.0429C0.0093196 11.6709 1.09742 10.5833 2.47044 10.5789C3.90831 10.5745 5.34617 10.5745 6.78403 10.5816C6.98118 10.5824 7.05087 10.5333 7.04955 10.3237C7.04425 9.58196 7.47032 9.16575 8.21042 9.16531C10.0298 9.16443 11.8492 9.16443 13.6686 9.16531C14.3888 9.16575 14.8219 9.59257 14.8189 10.314C14.818 10.5086 14.8616 10.5833 15.0742 10.582C16.4755 10.5727 17.8767 10.5807 19.2775 10.5758C20.1676 10.5727 20.8667 10.053 21.0616 9.2551C21.1013 9.09233 21.1256 8.92116 21.1269 8.75353C21.1335 7.97376 21.1393 7.19399 21.1269 6.41421C21.1137 5.56014 20.6118 4.88917 19.85 4.68262C19.3966 4.55966 18.9318 4.61362 18.4708 4.60742C18.3407 4.60566 18.3407 4.70296 18.3447 4.79363C18.3557 5.04043 18.3293 5.27839 18.1969 5.49468C17.9976 5.81932 17.7078 6.01172 17.3294 6.01305C15.4147 6.02013 13.5001 6.02013 11.5854 6.01393C11.0323 6.01217 10.5851 5.55129 10.5675 4.99753C10.5648 4.91659 10.5639 4.83565 10.5657 4.75471C10.5679 4.65475 10.5251 4.60521 10.4219 4.60521C9.83485 4.60654 9.24824 4.60654 8.66119 4.60566C8.54078 4.60566 8.52225 4.68085 8.51476 4.77992C8.47947 5.24566 8.47771 5.24522 8.0287 5.37172C7.92285 5.40135 7.81567 5.427 7.71114 5.4615C7.5184 5.52475 7.46194 5.65346 7.55633 5.83746C7.65733 6.0334 7.76848 6.22403 7.88139 6.41333C7.93961 6.51064 7.93344 6.5845 7.85096 6.66632C7.454 7.05909 7.06013 7.4545 6.66803 7.85213C6.58731 7.93395 6.51454 7.94589 6.41618 7.88618C6.25343 7.78667 6.08715 7.69246 5.91999 7.60046C5.63903 7.44565 5.52524 7.49387 5.44188 7.79728C5.39116 7.98172 5.33779 8.16527 5.29192 8.3506C5.26237 8.46913 5.19444 8.52044 5.07315 8.52C4.5302 8.51779 3.98726 8.51734 3.44475 8.52C3.31287 8.52044 3.24451 8.46073 3.21363 8.33423C3.16644 8.14139 3.11042 7.9512 3.05573 7.76013C2.98163 7.50094 2.85549 7.45052 2.61644 7.58454C2.44971 7.67786 2.28167 7.76853 2.12024 7.87026C2.0016 7.94501 1.91471 7.93749 1.81326 7.83311C1.44453 7.45406 1.07051 7.07987 0.692965 6.70923C0.587552 6.60573 0.560647 6.51506 0.645331 6.38325C0.756478 6.21032 0.85263 6.02765 0.950545 5.84675C1.05287 5.65833 0.999503 5.52077 0.79441 5.45841C0.598137 5.3987 0.399218 5.34651 0.199858 5.29741C0.0697451 5.26512 0.000498368 5.20409 0.00226262 5.05547C0.00976067 4.52029 0.00887854 3.9829 0.0035858 3.44595C0.00226261 3.30264 0.0587185 3.2332 0.196771 3.2018C0.396572 3.15624 0.594168 3.09874 0.79044 3.03903C0.995093 2.97711 1.05375 2.83867 0.954074 2.65202C0.85704 2.47068 0.755155 2.29155 0.647536 2.1164C0.575202 1.99919 0.576525 1.90985 0.681057 1.80723C1.06434 1.43216 1.44277 1.05223 1.81723 0.668313C1.91735 0.565258 2.00601 0.554642 2.12509 0.629391C2.2927 0.734658 2.46647 0.830637 2.63981 0.927058C2.85593 1.04736 2.98208 0.996056 3.0522 0.761196C3.12719 0.507316 3.2004 0.253437 3.27494 0C3.93521 0 4.59548 0 5.25575 0C5.32411 0.255206 5.38851 0.512182 5.46261 0.765619C5.52833 0.989864 5.658 1.0425 5.85824 0.932365C6.04481 0.829752 6.23094 0.726697 6.41265 0.616564C6.51895 0.551989 6.59878 0.567469 6.68435 0.65416C7.07116 1.04648 7.45974 1.43614 7.85096 1.82404C7.93211 1.90454 7.94358 1.9784 7.88448 2.07703C7.77157 2.26634 7.66174 2.45741 7.55853 2.65202C7.45797 2.84133 7.51796 2.97578 7.72217 3.03726C7.85537 3.07751 7.98945 3.11599 8.12397 3.15182C8.55401 3.26549 8.52093 3.23409 8.51387 3.64189C8.51079 3.81261 8.56812 3.87542 8.74234 3.87232C9.22619 3.86304 9.71003 3.86967 10.1939 3.86923C10.6142 3.86879 10.5613 3.89488 10.5675 3.50743C10.5772 2.92536 11.0226 2.46139 11.5969 2.45962C13.5032 2.45387 15.4094 2.45431 17.3157 2.46006C17.7232 2.46139 18.0236 2.66618 18.2216 3.024C18.3328 3.2248 18.3584 3.44153 18.3429 3.66444C18.3328 3.81527 18.3879 3.87586 18.5436 3.87144C18.844 3.86304 19.1448 3.86702 19.4456 3.87011C20.0838 3.87675 20.6281 4.11515 21.0943 4.54639C21.4974 4.91925 21.7153 5.39383 21.8503 5.91486C21.8503 7.03299 21.8503 8.15112 21.8503 9.26969C21.8361 9.31127 21.8189 9.3524 21.8092 9.39487C21.5398 10.5426 20.4821 11.3534 19.2687 11.3233C17.8983 11.2897 16.5262 11.3153 15.1549 11.3153C14.8277 11.3153 14.8277 11.3153 14.8228 11.6524C14.814 12.2698 14.3654 12.7254 13.7493 12.7267C11.8721 12.7298 9.99452 12.7271 8.11736 12.7289C7.9524 12.7289 7.79582 12.6984 7.64983 12.6245C7.21715 12.4043 7.02529 12.0438 7.04558 11.5639C7.05175 11.4184 7.04602 11.3113 6.8449 11.3127C5.40747 11.3193 3.97005 11.3043 2.53308 11.3211C1.49041 11.3335 0.763535 12.0633 0.742364 13.108C0.72384 14.0195 0.725604 14.932 0.741923 15.8436C0.759125 16.8171 1.3647 17.4783 2.33063 17.619C2.63717 17.6636 2.94635 17.6221 3.25289 17.6446C3.46151 17.6601 3.5312 17.5933 3.52899 17.3761C3.52194 16.6517 3.95329 16.2297 4.67884 16.2293C6.49028 16.2284 8.30172 16.2288 10.1127 16.2293C10.8819 16.2293 11.2952 16.6349 11.2979 17.4084C11.2983 17.5942 11.36 17.6468 11.5391 17.6446C12.3092 17.6367 13.0793 17.6358 13.849 17.6455C14.0342 17.6477 14.1061 17.5849 14.1343 17.4049C14.3906 15.7648 15.6392 14.4755 17.2623 14.1655C18.8625 13.8603 20.4971 14.6127 21.3382 16.0347C21.6041 16.4845 21.751 16.9732 21.8507 17.4805C21.8503 17.833 21.8503 18.186 21.8503 18.5389ZM21.1296 18.0046C21.0784 16.2133 19.7323 14.8679 17.9667 14.8533C16.247 14.8391 14.8122 16.2801 14.8294 18.0024C14.8471 19.7774 16.1945 21.1605 17.9755 21.1605C19.7552 21.16 21.0824 19.7858 21.1296 18.0046ZM2.11583 1.49895C2.03556 1.50249 2.00204 1.54362 1.96675 1.57989C1.88516 1.66437 1.80444 1.75018 1.72417 1.83554C1.49349 2.08101 1.47806 2.09207 1.66595 2.36807C1.84017 2.62416 1.90059 2.85725 1.70564 3.12705C1.64345 3.2133 1.61478 3.3283 1.58788 3.43445C1.55304 3.57245 1.471 3.63835 1.33647 3.67594C0.712813 3.85109 0.715459 3.85375 0.768387 4.50968C0.777208 4.62069 0.814698 4.69986 0.928492 4.71004C1.37573 4.75029 1.60023 4.99974 1.74181 5.42479C1.82517 5.67558 1.84105 5.85161 1.70123 6.07055C1.47629 6.42395 1.48291 6.43412 1.77224 6.71454C2.12598 7.05732 1.99763 7.0812 2.45236 6.80521C2.6676 6.67429 2.83785 6.68711 3.07867 6.76584C3.51223 6.90694 3.76143 7.14489 3.79892 7.60267C3.80951 7.73315 3.90875 7.77473 4.02254 7.75349C4.24792 7.71192 4.50374 7.86717 4.70089 7.64867C4.70971 7.63894 4.71236 7.62125 4.71368 7.60709C4.74588 7.12455 5.02772 6.89057 5.47231 6.75478C5.67917 6.69154 5.82648 6.66765 6.01923 6.77955C6.53395 7.07766 6.3562 7.09403 6.78315 6.67738C7.0791 6.38856 7.05264 6.46287 6.84622 6.13689C6.68038 5.87505 6.61378 5.64462 6.80696 5.37437C6.86474 5.29343 6.89341 5.18684 6.91811 5.08776C6.95648 4.93605 7.04117 4.86086 7.19598 4.81884C7.76142 4.6636 7.7526 4.6574 7.75657 4.06517C7.75789 3.88206 7.69703 3.78608 7.52016 3.76662C7.15276 3.72592 6.88591 3.57112 6.82681 3.16995C6.82064 3.12794 6.7977 3.08503 6.77168 3.05053C6.61951 2.84885 6.67068 2.66795 6.79064 2.46537C7.07778 1.98106 7.06807 2.11905 6.70111 1.74885C6.38531 1.43039 6.51145 1.42376 6.09597 1.67675C5.86 1.8205 5.658 1.87623 5.41541 1.70904C5.31573 1.64004 5.18827 1.60554 5.06874 1.57281C4.93333 1.53566 4.86585 1.45959 4.82792 1.32203C4.66649 0.74085 4.66208 0.748369 4.05783 0.749254C3.88493 0.749696 3.79583 0.810291 3.77555 0.977038C3.731 1.34238 3.58413 1.6166 3.17879 1.67145C3.13733 1.6772 3.09499 1.70197 3.06014 1.72762C2.86078 1.87446 2.67466 1.85323 2.48059 1.70816C2.36371 1.62147 2.22742 1.56176 2.11583 1.49895ZM14.4691 3.19384C13.568 3.19384 12.6665 3.19207 11.7654 3.19472C11.4372 3.19561 11.3062 3.32387 11.3027 3.64454C11.2983 4.04128 11.2983 4.43802 11.3027 4.83477C11.3062 5.14614 11.4368 5.27883 11.7482 5.27928C13.5508 5.28193 15.3534 5.28149 17.1556 5.27928C17.4771 5.27883 17.6046 5.1457 17.6077 4.8184C17.6112 4.44377 17.6099 4.0687 17.6081 3.69408C17.6064 3.31282 17.4882 3.19384 17.1066 3.1934C16.2276 3.19295 15.3486 3.19384 14.4691 3.19384ZM10.9177 11.9907C11.8117 11.9907 12.7057 11.992 13.5993 11.9903C13.9641 11.9894 14.0849 11.866 14.0871 11.498C14.0889 11.1158 14.0907 10.7337 14.0862 10.3516C14.0827 10.0389 13.953 9.90528 13.643 9.90484C11.8404 9.90218 10.0377 9.90262 8.23556 9.90439C7.91271 9.90483 7.7848 10.0371 7.78171 10.3631C7.77818 10.7306 7.77995 11.0977 7.78083 11.4653C7.78171 11.877 7.8933 11.9898 8.30216 11.9903C9.1737 11.9916 10.0457 11.9907 10.9177 11.9907ZM7.41386 16.9657C6.51983 16.9657 5.6258 16.9644 4.73221 16.9666C4.39083 16.9675 4.26292 17.0935 4.25983 17.4292C4.2563 17.8184 4.25586 18.2081 4.25983 18.5973C4.26292 18.9211 4.39215 19.0516 4.7181 19.052C6.51322 19.0542 8.30834 19.0542 10.1039 19.052C10.4382 19.0516 10.563 18.9207 10.5657 18.5783C10.5683 18.2108 10.5675 17.8437 10.5661 17.4761C10.5648 17.082 10.4488 16.9661 10.0519 16.9657C9.17238 16.9648 8.2929 16.9657 7.41386 16.9657Z"
                />
                <path
                  d="M19.9876 16.8485C19.9519 16.894 19.9246 16.9369 19.8893 16.9723C18.9423 17.9233 17.994 18.8724 17.0484 19.8243C16.9558 19.9176 16.8857 19.9207 16.7935 19.8252C16.5487 19.5722 16.3008 19.3223 16.0481 19.0772C15.8942 18.9282 16.0322 18.8353 16.1231 18.7853C16.2713 18.7035 16.2924 18.3718 16.5712 18.5447C16.5893 18.5558 16.6029 18.5752 16.6184 18.5903C16.9254 18.8884 16.9254 18.8884 17.2218 18.5907C17.9208 17.8897 18.623 17.1921 19.3155 16.4849C19.4509 16.3465 19.5426 16.3314 19.6644 16.4858C19.7367 16.5774 19.8293 16.6521 19.91 16.7375C19.9396 16.7684 19.9594 16.8073 19.9876 16.8485Z"
                />
                <path
                  d="M4.25718 2.10712C5.43261 2.10712 6.40912 3.0899 6.39898 4.262C6.38883 5.42391 5.40041 6.40891 4.25453 6.39918C3.07205 6.38901 2.1145 5.41993 2.11891 4.23811C2.12288 3.07 3.08925 2.10712 4.25718 2.10712ZM2.88327 4.23767C2.87974 5.01567 3.48135 5.63179 4.24836 5.63666C5.0061 5.64153 5.63903 5.01125 5.63814 4.25226C5.63726 3.4893 5.03477 2.88025 4.27438 2.87406C3.49017 2.86743 2.8868 3.45878 2.88327 4.23767Z"
                />
                <path
                  d="M12.7101 4.21863C12.7101 4.60609 12.7101 4.60609 12.3392 4.60609C11.9749 4.60609 11.9749 4.60609 11.9749 4.23411C11.9749 3.86877 11.9749 3.86877 12.3458 3.86877C12.7097 3.86877 12.7097 3.86877 12.7101 4.21863Z"
                />
                <path
                  d="M13.7599 3.86877C14.1185 3.86877 14.1198 3.86877 14.118 4.2465C14.1163 4.6481 14.1462 4.60343 13.7197 4.60564C13.3828 4.60741 13.3828 4.60564 13.3832 4.20625C13.3837 3.86877 13.3837 3.86877 13.7599 3.86877Z"
                />
                <path
                  d="M15.5272 4.23809C15.5272 4.60608 15.5272 4.60608 15.159 4.60608C14.792 4.60608 14.792 4.60608 14.792 4.23677C14.792 3.86833 14.792 3.86833 15.1823 3.86877C15.5272 3.86922 15.5272 3.86922 15.5272 4.23809Z"
                />
                <path
                  d="M16.5575 4.6061C16.2003 4.6061 16.1994 4.6061 16.2007 4.22705C16.2025 3.82721 16.1725 3.87188 16.6007 3.86967C16.9364 3.8679 16.9364 3.86967 16.936 4.27039C16.9351 4.60654 16.9351 4.60654 16.5575 4.6061Z"
                />
                <path
                  d="M8.82169 10.5785C9.18865 10.5785 9.18865 10.5785 9.18865 10.9478C9.18865 11.3162 9.18865 11.3162 8.79831 11.3158C8.45296 11.3153 8.45296 11.3153 8.4534 10.9243C8.4534 10.5785 8.4534 10.5785 8.82169 10.5785Z"
                />
                <path
                  d="M10.597 10.9575C10.597 11.3158 10.597 11.3166 10.219 11.3153C9.82024 11.3135 9.86479 11.3436 9.86259 10.9141C9.86082 10.5776 9.86259 10.5776 10.2622 10.578C10.5974 10.5789 10.5974 10.5789 10.597 10.9575Z"
                />
                <path
                  d="M11.6556 10.5785C12.0058 10.5785 12.0058 10.5785 12.0058 10.9646C12.0053 11.3158 12.0053 11.3158 11.6207 11.3158C11.2701 11.3153 11.2701 11.3153 11.2705 10.9075C11.271 10.578 11.271 10.578 11.6556 10.5785Z"
                />
                <path
                  d="M13.4144 10.9478C13.4144 11.3158 13.4144 11.3158 13.0462 11.3158C12.6792 11.3158 12.6792 11.3158 12.6792 10.9465C12.6792 10.578 12.6792 10.578 13.0695 10.5785C13.4144 10.5785 13.4144 10.5785 13.4144 10.9478Z"
                />
                <path
                  d="M5.66732 18.021C5.66732 18.3784 5.66732 18.3793 5.288 18.3779C4.89061 18.3762 4.93471 18.4063 4.93251 17.9759C4.93074 17.6402 4.93251 17.6402 5.33343 17.6411C5.66732 17.6415 5.66732 17.6415 5.66732 18.021Z"
                />
                <path
                  d="M6.69225 18.378C6.34029 18.378 6.34029 18.378 6.34073 17.9932C6.34073 17.6402 6.34073 17.6402 6.72445 17.6407C7.07686 17.6407 7.07686 17.6407 7.07598 18.0471C7.0751 18.3784 7.0751 18.3784 6.69225 18.378Z"
                />
                <path
                  d="M8.48427 17.9936C8.48074 18.4116 8.52 18.3762 8.11069 18.378C7.74902 18.3793 7.74902 18.3784 7.74902 18.0038C7.74902 17.6411 7.74902 17.6411 8.1226 17.6411C8.48427 17.6411 8.48427 17.6411 8.48427 17.9936Z"
                />
                <path
                  d="M9.52836 17.6406C9.89267 17.6406 9.89267 17.6406 9.89267 18.0126C9.89267 18.3784 9.89267 18.3784 9.49969 18.3779C9.15698 18.3775 9.15698 18.3775 9.15698 18.006C9.15786 17.6406 9.15786 17.6406 9.52836 17.6406Z"
                />
              </svg>
            </div>
            <div class="ml-2">
              <div :style="`color:${highlighted_color};`">Metodología</div>
              <div>
                {{ methodology_text }}
              </div>
            </div>
          </div>
          <div class="mt-3 content-style">
            <div
              class="d-flex"
              :style="`border-right: ${text_color} 1px solid;`"
            >
              <svg
                width="22"
                height="22"
                class="mr-3"
                style="margin-top: auto; margin-bottom: auto"
                :fill="`${highlighted_color}`"
                viewBox="0 0 21 21"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.902 3.26497C19.8736 4.30132 18.8452 5.33766 17.8173 6.37443C17.6813 6.51168 17.5275 6.52953 17.3521 6.46282C16.8381 6.26821 16.3199 6.08592 15.8106 5.87984C15.628 5.80591 15.5191 5.84628 15.3877 5.97842C13.8776 7.50086 12.3619 9.01777 10.8472 10.536C10.7823 10.6005 10.7192 10.6698 10.6446 10.7212C10.5065 10.8164 10.3611 10.8134 10.2404 10.6928C10.1192 10.5721 10.1154 10.4263 10.2095 10.2874C10.2603 10.2122 10.3294 10.1493 10.3938 10.0843C11.8925 8.58054 13.3886 7.07383 14.8958 5.57774C15.0742 5.40055 15.1085 5.25736 15.0114 5.02706C14.8144 4.55924 14.653 4.07612 14.4695 3.60235C14.3894 3.395 14.4149 3.23013 14.5793 3.06697C15.4555 2.19804 16.325 1.32146 17.197 0.447851C17.3461 0.298284 17.4961 0.149142 17.6461 0C17.7448 0 17.8436 0 17.9423 0C18.0372 0.0888053 18.0961 0.197156 18.1389 0.320379C18.3249 0.860859 18.5198 1.39836 18.7016 1.93969C18.7491 2.08119 18.827 2.15937 18.9681 2.20696C19.5084 2.38967 20.0439 2.58513 20.5829 2.77123C20.7058 2.81373 20.8138 2.87321 20.9024 2.96797C20.902 3.06739 20.902 3.1664 20.902 3.26497ZM17.6254 0.929694C17.5987 0.950939 17.5639 0.973884 17.5355 1.00278C16.7576 1.78163 15.9809 2.56176 15.2025 3.34018C15.1292 3.41369 15.1085 3.48763 15.1466 3.58748C15.2852 3.95035 15.4203 4.31449 15.5534 4.67906C15.5979 4.80101 15.6474 4.81716 15.7436 4.72028C16.5139 3.94355 17.2868 3.1698 18.0597 2.39604C18.1275 2.32806 18.1431 2.26092 18.1097 2.16787C17.9728 1.7897 17.8427 1.40856 17.7084 1.02912C17.6948 0.99258 17.6881 0.944565 17.6254 0.929694ZM17.383 5.79444C17.466 5.81398 17.519 5.76639 17.5698 5.71498C18.3474 4.9357 19.124 4.15515 19.9037 3.378C20.0062 3.2756 19.9744 3.23523 19.8558 3.19444C19.5029 3.07292 19.1495 2.95182 18.8008 2.81797C18.6622 2.76486 18.5698 2.78738 18.4652 2.89318C17.7215 3.64654 16.9724 4.39437 16.225 5.14391C16.2 5.16898 16.1754 5.19405 16.1521 5.22082C16.1084 5.27053 16.1173 5.31302 16.1779 5.33597C16.5796 5.48978 16.9813 5.64147 17.383 5.79444Z"
                />
                <path
                  d="M20.902 19.4212C20.4538 19.8707 20.0055 20.3207 19.5563 20.7698C19.5067 20.8195 19.458 20.8743 19.3991 20.91C19.2546 20.9976 19.1135 20.9818 18.9974 20.8561C18.8796 20.7282 18.8741 20.5799 18.9873 20.4537C19.175 20.2434 19.3792 20.0479 19.5741 19.844C19.636 19.7789 19.7173 19.7292 19.7508 19.6332C19.6754 19.5707 19.5877 19.6001 19.508 19.6001C17.9297 19.5979 16.3513 19.5988 14.7726 19.5975C14.6747 19.5975 14.5738 19.5958 14.4798 19.5724C14.3166 19.5325 14.226 19.4169 14.2366 19.247C14.2471 19.0761 14.356 18.9797 14.5204 18.9538C14.5963 18.9419 14.6751 18.9461 14.7526 18.9461C16.3522 18.9457 17.9517 18.9461 19.5512 18.9449C19.6258 18.9449 19.7042 18.9657 19.8055 18.9075C19.5945 18.698 19.3907 18.4974 19.1885 18.2952C19.1186 18.2255 19.0462 18.1571 18.9856 18.0797C18.8873 17.9535 18.8805 17.8163 18.986 17.6918C19.0966 17.5618 19.2385 17.5465 19.3877 17.62C19.4368 17.6442 19.4813 17.6837 19.5203 17.7232C19.9817 18.1898 20.4419 18.6572 20.9025 19.1246C20.9021 19.2236 20.902 19.3226 20.902 19.4212Z"
                />
                <path
                  d="M4.59276 10.3528C4.59403 13.3769 6.72448 15.8498 9.58881 16.2811C12.7786 16.7613 15.7556 14.5696 16.2441 11.3794C16.4708 9.89945 16.1687 8.53041 15.3692 7.26929C15.3463 7.23359 15.3221 7.19875 15.3022 7.16136C15.2086 6.98502 15.2429 6.80741 15.3874 6.71181C15.5361 6.61323 15.7103 6.6451 15.831 6.81209C16.0721 7.14479 16.259 7.51021 16.4234 7.88582C17.4492 10.2232 16.967 13.031 15.2281 14.8917C14.1073 16.0908 12.7341 16.8003 11.107 16.958C9.26551 17.1369 7.61768 16.6164 6.21305 15.4016C4.91266 14.2773 4.1576 12.8419 3.99193 11.1304C3.81185 9.26889 4.33599 7.60496 5.56773 6.19002C6.68677 4.90469 8.10834 4.16577 9.7977 3.99071C11.3358 3.83137 12.7625 4.19212 14.0586 5.04788C14.2035 5.14348 14.3056 5.26501 14.2433 5.45451C14.1925 5.60875 14.0751 5.67674 13.9175 5.66952C13.823 5.66527 13.7459 5.61045 13.6692 5.55989C13.0197 5.13074 12.312 4.84477 11.5481 4.70031C8.31088 4.08674 5.20291 6.27118 4.67369 9.53361C4.62327 9.84676 4.59657 10.1629 4.59276 10.3528Z"
                />
                <path
                  d="M18.6474 8.49129C18.5729 8.50404 18.5635 8.57627 18.5334 8.62726C18.4216 8.8155 18.3178 9.0084 18.2029 9.19451C18.0894 9.37807 17.9135 9.43161 17.7534 9.34238C17.5919 9.25272 17.5458 9.07596 17.6517 8.88263C17.8385 8.54228 18.0207 8.19768 18.2339 7.87433C18.3746 7.66103 18.4 7.47279 18.2767 7.25142C18.2118 7.13499 18.1627 7.00795 18.1207 6.8809C18.0614 6.70287 18.1144 6.55967 18.2873 6.47469C18.4419 6.39863 18.6059 6.45345 18.6936 6.62893C18.7915 6.82396 18.8733 7.02792 18.9521 7.23187C18.9953 7.34362 19.0597 7.42138 19.1648 7.48044C19.5211 7.68057 19.8732 7.88835 20.227 8.09358C20.2698 8.11823 20.3139 8.14117 20.3537 8.16964C20.522 8.28946 20.5686 8.4556 20.4787 8.60899C20.3902 8.76068 20.2135 8.81125 20.0372 8.71904C19.8436 8.61791 19.6576 8.50234 19.4677 8.39441C19.4266 8.37104 19.3817 8.32303 19.3355 8.3583C19.2881 8.39441 19.3262 8.45008 19.336 8.49639C19.4851 9.21066 19.5703 9.93172 19.5508 10.6621C19.4309 15.136 16.1979 18.695 12.0934 19.4403C11.5095 19.5461 10.9218 19.5975 10.329 19.5979C7.0596 19.5988 3.79062 19.5983 0.521216 19.5979C0.422914 19.5979 0.323762 19.6068 0.228002 19.5724C0.0792772 19.5189 -0.00716098 19.4186 0.000465939 19.255C0.00809285 19.0914 0.104702 18.9937 0.255969 18.9597C0.343678 18.9401 0.438168 18.9461 0.529267 18.9461C3.87621 18.9448 7.22315 18.9631 10.5697 18.9376C12.8844 18.9198 14.8624 18.0461 16.489 16.3971C17.7513 15.1177 18.5169 13.5749 18.8025 11.8005C18.9745 10.7314 18.9445 9.66191 18.697 8.60347C18.689 8.56948 18.6779 8.53633 18.6665 8.50362C18.6661 8.49852 18.6563 8.49639 18.6474 8.49129Z"
                />
                <path
                  d="M1.69193 7.88795C1.78134 7.81784 1.78007 7.73371 1.80549 7.66318C3.06817 4.15643 5.53081 2.06632 9.19428 1.45063C10.8794 1.16722 12.52 1.43576 14.0903 2.11433C14.1742 2.15045 14.2607 2.18657 14.3344 2.23968C14.4602 2.33061 14.5179 2.45426 14.4505 2.60935C14.3827 2.76614 14.2594 2.83115 14.0924 2.80311C14.0378 2.79376 13.9848 2.76996 13.9336 2.74659C12.6976 2.18572 11.398 1.9431 10.0468 2.00853C6.43376 2.18317 3.40079 4.64082 2.37624 7.99673C2.36861 8.02222 2.36607 8.04942 2.3559 8.10253C2.56437 8.03964 2.71564 7.91302 2.88597 7.82549C2.98004 7.77705 3.06902 7.71926 3.16435 7.67337C3.33045 7.59392 3.47324 7.64023 3.56815 7.78937C3.66603 7.94319 3.63214 8.09615 3.48934 8.20196C3.35418 8.30223 3.20249 8.38042 3.05673 8.46582C2.80122 8.61581 2.54742 8.76878 2.28726 8.90985C2.16777 8.97486 2.11904 9.06749 2.09997 9.19454C1.55762 12.8135 3.39443 16.3805 6.65748 18.0423C6.96001 18.1966 7.05196 18.3593 6.94645 18.5552C6.84434 18.7447 6.66637 18.7698 6.37443 18.6151C3.64485 17.1687 2.00718 14.9218 1.47711 11.8706C1.31652 10.9447 1.3233 10.0155 1.47457 9.08788C1.50211 8.91962 1.47287 8.77218 1.38304 8.62389C1.17118 8.27334 0.969495 7.91684 0.769501 7.5595C0.647046 7.3411 0.682216 7.16051 0.85255 7.06363C1.02246 6.96718 1.19534 7.03219 1.32415 7.24847C1.44872 7.4588 1.56779 7.67167 1.69193 7.88795Z"
                />
                <path
                  d="M6.33756 10.2746C6.39392 8.42332 7.82863 6.6264 9.95696 6.36083C10.7569 6.26098 11.529 6.3893 12.2577 6.74622C12.5128 6.87114 12.5967 7.03813 12.5022 7.22382C12.4116 7.40185 12.2319 7.43754 11.9874 7.32537C10.4858 6.63702 8.89343 6.94593 7.81973 8.19303C6.91382 9.24509 6.7079 10.4705 7.21848 11.7593C7.71804 13.02 8.6786 13.7567 10.0298 13.9428C11.8972 14.1999 13.5819 12.861 13.892 11.1049C14.0187 10.3868 13.9272 9.69974 13.642 9.03434C13.6196 8.9825 13.5916 8.93321 13.5704 8.88095C13.4848 8.66934 13.542 8.48919 13.717 8.41398C13.884 8.34217 14.0399 8.4144 14.1458 8.61198C14.9145 10.0443 14.6594 11.9942 13.5475 13.2197C12.72 14.1315 11.6887 14.6206 10.465 14.618C8.08159 14.6129 6.41892 12.7034 6.33756 10.7187C6.33206 10.5631 6.30663 10.4085 6.33756 10.2746Z"
                />
                <path
                  d="M10.5307 12.2381C9.66162 12.3049 8.80529 11.5889 8.7125 10.7183C8.60784 9.73248 9.25612 8.8474 10.1697 8.72927C10.3874 8.70123 10.5417 8.78876 10.5832 8.9651C10.626 9.14696 10.5197 9.30332 10.2908 9.35346C9.81374 9.45841 9.49256 9.7295 9.36883 10.2084C9.21714 10.7952 9.57688 11.4028 10.1591 11.5604C10.7557 11.7219 11.3713 11.3756 11.537 10.7854C11.5599 10.7038 11.5709 10.618 11.6031 10.5402C11.6641 10.3928 11.7819 10.3201 11.94 10.3452C12.0976 10.3703 12.1861 10.4739 12.2014 10.6346C12.2132 10.7641 12.1747 10.8869 12.1378 11.008C11.9222 11.7104 11.3103 12.1782 10.5307 12.2381Z"
                />
              </svg>
            </div>
            <div class="ml-2">
              <div :style="`color:${highlighted_color};`">
                Resultado de aprendizaje
              </div>
              <div>
                {{ ra_text }}
              </div>
            </div>
          </div>
          <div class="content-class" v-if="contents_texts.length > 0">
            <div class="mb-3" :style="`color:${highlighted_color}`">
              <strong> Contenido </strong>
            </div>
            <div
              v-for="(item, index) in contents_texts"
              :key="index"
              class="d-flex"
            >
              <div class="mr-1" :style="`color:${highlighted_color}`">
                <b-icon icon="caret-right-fill" aria-hidden="true"></b-icon>
              </div>
              <div class="ml-1">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingCard",
  components: {},
  props: {
    background_card: {
      type: String,
      default: "#FFFFFF",
    },
    counter: {
      type: Number,
    },
    tittle_icon: {
      type: String,
      default: null,
    },
    tittle: {
      type: String,
      default: "",
    },
    imagen_left: {
      type: String,
      default: null,
    },
    duration_text: {
      type: String,
      default: "",
    },
    methodology_text: {
      type: String,
      default: "",
    },
    ra_text: {
      type: String,
      default: "",
    },
    evaluation_criteria_texts: {
      type: Array,
      default: function () {
        return [];
      },
    },
    contents_texts: {
      type: Array,
      default: function () {
        return [];
      },
    },
    text_color: {
      type: String,
      default: "#FFFFFF",
    },
    highlighted_color: {
      type: String,
      default: "#FFFFFF",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped>
.global-style {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5rem;
  border-radius: 25px;
  font-size: 14px;
}
.hidden-img {
  display: none !important;
}
.show-img {
  display: flex !important;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: auto;
}
.left-container {
  width: 50%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.left-sub-container {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.img-left {
  height: auto;
  width: 100%;
  border-radius: 10px;
  max-width: 600px;
  max-height: 380px;
}
.index-styles {
  position: absolute;
  width: 18.6px;
  height: 18.6px;
  border-radius: 50%;
}
.index-text {
  margin-top: 0px;
}
.right-container {
  margin-top: 3rem;
  margin-bottom: 3rem;
  width: 50%;
  text-align: left;
  margin-left: 1rem;
}
.tittle-style {
  font-size: 32px;
  align-items: flex-start;
  line-height: normal;
}
.duration-style {
  font-size: 16px;
}
.content-style {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: auto;
  font-size: 14px;
}
.content-class {
  margin-top: 2rem;
  margin-left: 2rem;
  text-align: left;
}
@media (max-width: 1000px) {
  .hidden-img {
    display: flex !important;
  }
  .show-img {
    display: none !important;
  }
  .flex-container {
    flex-direction: column-reverse;
    height: auto;
  }
  .left-container {
    width: 100%;
    margin-top: 0rem;
  }
  .right-container {
    margin-left: 0rem;
    margin-bottom: 0rem;
    width: 90%;
    align-self: center;
  }
}
@media (max-width: 600px) {
  .global-style {
    width: 100%;
    border-radius: 25px;
  }
  .right-container {
    margin-left: 2rem;
    width: 90%;
  }
  .img-left {
    width: 90%;
  }
  .index-text {
    margin-top: -5px;
  }
  .content-class {
    margin-left: 0.5rem;
  }
}
@media (max-width: 400px) {
  .right-container {
    margin-left: 0;
    width: 80%;
  }
}
</style>